import { useContext, useState } from "react";
import { ProjectContext } from "context/ProjectProvider";
import { useCIQMutation } from "hooks/ciq-gql-hooks";
import { MUTATION_SEND_SC_REQUEST_DUMMY_INVITE } from "../mutations";

/**
 * Wraps the (local) send-invite mutation for the SC-request page.
 *
 * Mirrors the calling pattern of
 * `components/request-durations/hooks/request-durations.ts`: it resolves the
 * project GraphQL client from `ProjectContext`, tracks an in-flight flag, and
 * exposes a `sendInvite(variables)` that returns the standard
 * `{ success, ... }` response shape from `useCIQMutation` (which already
 * surfaces GraphQL errors itself).
 */
export const useScRequestInvite = () => {
  const { gqlClientForProject } = useContext(ProjectContext);

  const [sendingInvite, setSendingInvite] = useState(false);

  const [sendInviteMutation] = useCIQMutation(
    MUTATION_SEND_SC_REQUEST_DUMMY_INVITE,
    {
      client: gqlClientForProject
    }
  );

  const sendInvite = async (variables: any) => {
    setSendingInvite(true);
    const response = await sendInviteMutation({ variables });
    setSendingInvite(false);
    return response;
  };

  return { sendInvite, sendingInvite };
};
